import marqii from '@/assets/images/marqii.svg'
import { ConditionalComponent } from '@/components/ConditionalComponent/ConditionalComponent'
import { Image } from '@/components/Image'
import { ImpersonatingBanner } from '@/components/ImpersonatingBanner'
import { QuickNavigationButton } from '@/components/layouts/Header/QuickNavigationButton'
import { UserProfileDropdown } from '@/components/layouts/Header/UserProfileDropdown'
import { PaymentIssueWarningBanner } from '@/components/PaymentIssueWarningBanner/PaymentIssueWarningBanner'
import { Space } from '@/components/Space'
import { DashboardExperiments } from '@/experiments'
import { useFlag } from '@/hooks/useFlag'
import { PATHS } from '@/routes/PATHS'
import { usePremiumFeaturesStatus } from '@/stores/permissions/premiumFeatures'
import { Layout } from 'antd'
import { Link } from 'react-router'
import { BeamerWidget } from './Beamer/BeamerWidget'
import styles from './styles.module.scss'

export const HEADER_TEST_ID = 'header-test-id'

interface HeaderProps {
  onQuickNavigationClick?: () => void
}

export function Header({ onQuickNavigationClick }: HeaderProps) {
  const shouldEnforceBillingFoundations = useFlag(
    DashboardExperiments.shouldEnforceBillingFoundations,
  )
  const premiumFeaturesStatus = usePremiumFeaturesStatus()

  const hasQuickNavigationFeature = useFlag(DashboardExperiments.quickNavigation)

  const shouldBlockAccount =
    premiumFeaturesStatus &&
    premiumFeaturesStatus === 'SUSPENDED' &&
    shouldEnforceBillingFoundations

  const shouldShowBeamer = !shouldBlockAccount

  return (
    <div>
      <ImpersonatingBanner />
      <PaymentIssueWarningBanner />

      <Layout.Header data-testid={HEADER_TEST_ID} className={styles.header}>
        <Link to={PATHS.homePage}>
          <Space align="center">
            <Image src={marqii} width="100px" />
          </Space>
        </Link>
        <div className={styles.iconContainer}>
          <ConditionalComponent condition={shouldShowBeamer}>
            <BeamerWidget />
          </ConditionalComponent>
          <ConditionalComponent condition={hasQuickNavigationFeature}>
            <QuickNavigationButton onClick={() => onQuickNavigationClick?.()} />
          </ConditionalComponent>
        </div>
        <UserProfileDropdown />
      </Layout.Header>
    </div>
  )
}
